<template>
    <div>
        <h1>Landing Vue</h1>
    </div>
</template>
<script>
export default {
    name: "Default",
}
</script>
<style lang="scss" scoped>

</style>
